/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiTokenDto } from '../models';
/**
 * ApiTokenApi - axios parameter creator
 * @export
 */
export const ApiTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать API токен
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerCreateApiToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/token/createApiToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить API токен
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerDeleteApiToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiTokenControllerDeleteApiToken', 'token', token)
            const localVarPath = `/token/deleteApiToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить количество API токенов по userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerGetApiTokenCountByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiTokenControllerGetApiTokenCountByUserId', 'userId', userId)
            const localVarPath = `/token/getApiTokenCountByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список API токенов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerGetApiTokens: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/token/getApiTokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить количество своих API токенов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerGetMyApiTokenCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/token/getMyApiTokenCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiTokenApi - functional programming interface
 * @export
 */
export const ApiTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать API токен
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTokenControllerCreateApiToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTokenControllerCreateApiToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.apiTokenControllerCreateApiToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить API токен
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTokenControllerDeleteApiToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTokenControllerDeleteApiToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.apiTokenControllerDeleteApiToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить количество API токенов по userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTokenControllerGetApiTokenCountByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTokenControllerGetApiTokenCountByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.apiTokenControllerGetApiTokenCountByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить список API токенов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTokenControllerGetApiTokens(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTokenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTokenControllerGetApiTokens(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.apiTokenControllerGetApiTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить количество своих API токенов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTokenControllerGetMyApiTokenCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTokenControllerGetMyApiTokenCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.apiTokenControllerGetMyApiTokenCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiTokenApi - factory interface
 * @export
 */
export const ApiTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiTokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать API токен
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerCreateApiToken(options?: RawAxiosRequestConfig): AxiosPromise<ApiTokenDto> {
            return localVarFp.apiTokenControllerCreateApiToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить API токен
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerDeleteApiToken(token: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiTokenControllerDeleteApiToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить количество API токенов по userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerGetApiTokenCountByUserId(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiTokenControllerGetApiTokenCountByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список API токенов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerGetApiTokens(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTokenDto>> {
            return localVarFp.apiTokenControllerGetApiTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить количество своих API токенов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenControllerGetMyApiTokenCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiTokenControllerGetMyApiTokenCount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiTokenApi - object-oriented interface
 * @export
 * @class ApiTokenApi
 * @extends {BaseAPI}
 */
export class ApiTokenApi extends BaseAPI {
    /**
     * 
     * @summary Создать API токен
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public apiTokenControllerCreateApiToken(options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).apiTokenControllerCreateApiToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить API токен
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public apiTokenControllerDeleteApiToken(token: string, options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).apiTokenControllerDeleteApiToken(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить количество API токенов по userId
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public apiTokenControllerGetApiTokenCountByUserId(userId: string, options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).apiTokenControllerGetApiTokenCountByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список API токенов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public apiTokenControllerGetApiTokens(options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).apiTokenControllerGetApiTokens(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить количество своих API токенов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public apiTokenControllerGetMyApiTokenCount(options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).apiTokenControllerGetMyApiTokenCount(options).then((request) => request(this.axios, this.basePath));
    }
}

